import React, { useMemo } from 'react';
import { ExperimentalChoroplethChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { buildChartTitle } from "../chartHelpers";
import geoData from "./europe.json";

const Index = ({ chart }) => {
    const chartOptions = useMemo(() => ({
        title: buildChartTitle(chart),
        geoData,
        experimental: true,
        height: '400px'
    }), [chart]);

    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = panelData
                    .filter(e => e != null)
                    .map(e => ({ ...e, value: e.value != null ? Number(e.value) : 0 }));
                return <ExperimentalChoroplethChart data={data} options={chartOptions} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
